/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_History_EmptyInputs */

const vi_sl_lot_history_empty = /** @type {(inputs: Sl_Lot_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô chưa có giao dịch nào.`)
};

/**

* @param {Sl_Lot_History_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_history_empty = /** @type {((inputs?: Sl_Lot_History_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_History_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_history_empty(inputs)
});